import PropTypes from 'prop-types'

export default (PropTypes.shape({
  animals: PropTypes.arrayOf(PropTypes.object),
  application_id: PropTypes.string,
  comment: PropTypes.string,
  division_id: PropTypes.string,
  end_date: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  group_info: PropTypes.arrayOf(PropTypes.object),
  groupsize: PropTypes.number,
  id: PropTypes.string,
  lottery_id: PropTypes.string,
  lottery_preferences: PropTypes.arrayOf(PropTypes.object),
  order_id: PropTypes.string,
  permit_id: PropTypes.string,
  permit_type: PropTypes.string,
  pickup_location_id: PropTypes.string,
  start_date: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  status: PropTypes.number,
  transaction_ids: PropTypes.arrayOf(PropTypes.string)
}));
